import React, { useContext } from "react";
import PropTypes from "prop-types";
import Button from "components/Button";
import { CaretDown, CaretUp } from "phosphor-react";
import usePremium from "hooks/usePremium";
import { MapContext } from "context/map";
import "./index.scss";

const ActionListMenu = ({
  menuOpened,
  toggleMenu,
  handleBookEm,
  handleExportMap,
  handleCreateZones,
  handleStackAnalysis,
}) => {
  const { isPremium } = usePremium();
  const { state } = useContext(MapContext);
  const { fields } = state;
  const actions = [
    {
      id: "order-high-res",
      title: "Order High Resolution",
      handleClick: () => {
        window.open("/order/high-resolution-imagery", "_blank");
      },
    },
    {
      id: "book-rapid-em",
      title: "Book Rapid-EM™ Machine",
      handleClick: () => {
        handleBookEm();
      },
    },
    {
      id: "export-map",
      title: "Export Map",
      handleClick: () => {
        handleExportMap();
      },
    },
    {
      id: "create-zones",
      title: "Create Zones",
      handleClick: () => {
        handleCreateZones();
      },
      disabled: !fields.length,
    },
    {
      id: "stack-analysis",
      title: "Stack Analysis",
      handleClick: () => {
        handleStackAnalysis();
      },
    },
  ];

  const renderLabel = () => {
    return (
      <div
        className={`menu-button ${
          menuOpened === "action-list" ? "-active" : ""
        }`}
        onClick={() =>
          menuOpened === "action-list"
            ? toggleMenu(null)
            : toggleMenu("action-list")
        }
        aria-hidden
      >
        <label className="action-label">Actions</label>
        {menuOpened === "action-list" ? (
          <CaretUp size={16} weight="fill" color="#B6B9C2" />
        ) : (
          <CaretDown size={16} weight="fill" color="#B6B9C2" />
        )}
      </div>
    );
  };

  const renderActions = () => {
    return (
      <div className="fill-list">
        {actions.map((item) => {
          if (isPremium) {
            return (
              <Button
                key={item.id}
                onClick={item.handleClick}
                aria-hidden
                label={item.title}
              />
            );
          }
          if (item.id === "export-map") {
            return null;
          }
          return (
            <Button
              key={item.id}
              onClick={item.handleClick}
              aria-hidden
              label={item.title}
            />
          );
        })}
      </div>
    );
  };
  const renderActionsContainer = () => {
    return (
      <div
        className={`list-container ${
          menuOpened === "action-list" ? "" : "-hidden"
        }`}
      >
        <p className="container-title">Actions</p>
        {renderActions()}
      </div>
    );
  };
  return (
    <>
      <div className="menu-container -layer" data-tour="step-5">
        <div>
          {renderLabel()}
          {renderActionsContainer()}
        </div>
      </div>
    </>
  );
};

ActionListMenu.defaultProps = {
  menuOpened: null,
};

ActionListMenu.propTypes = {
  menuOpened: PropTypes.string,
  toggleMenu: PropTypes.func.isRequired,
  handleBookEm: PropTypes.func.isRequired,
  handleExportMap: PropTypes.func.isRequired,
  handleCreateZones: PropTypes.func.isRequired,
  handleStackAnalysis: PropTypes.func.isRequired,
};

export default ActionListMenu;
